export default "__VITE_ASSET__CeszcWOQ__"